import { useCallback } from "react";
import { useNavigate } from "react-router";
import { SignupForm } from "@app/components/organisms/signup-form";

export function SignupPage() {
  const navigate = useNavigate();

  const handleSwitchToLogin = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  return (
    <section className="events-page events-auth-page">
      <div className="events-auth-card events-auth-card--page">
        <SignupForm onSwitchToLogin={handleSwitchToLogin} headingAs="h1" />
      </div>
    </section>
  );
}
